import { jsx as l, Fragment as nr, jsxs as f } from "react/jsx-runtime";
import * as s from "react";
import I, { forwardRef as P, useId as ar, useMemo as Lr, createElement as me, useEffect as ve } from "react";
import "react-dom";
function he(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var gr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var cr;
function ye() {
  return cr || (cr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a.call(this, o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, this && this[o] || o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(gr)), gr.exports;
}
var $e = ye();
const be = /* @__PURE__ */ he($e), xe = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, we = be.bind(xe), _r = "purpur-icon", Ne = "md", Se = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), je = ({ content: e = "", title: n } = {}) => {
  const t = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], a = n ? `<title>${n}</title>` : "";
  return `<svg ${Se(t)}>${a}${e}</svg>`;
}, Oe = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), pr = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: t,
  className: a,
  size: p = Ne,
  ...r
}) => {
  const i = je({
    content: Oe(n.svg),
    title: t
  }), o = we(a, _r, `${_r}--${p}`);
  return /* @__PURE__ */ l(
    "span",
    {
      className: o,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: i },
      ...r
    }
  );
};
pr.displayName = "Icon";
const Ce = {
  name: "arrow-left",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 12a.9.9 0 0 1 .264-.636l5.5-5.5a.9.9 0 0 1 1.272 1.272L6.173 11.1H20a.9.9 0 0 1 0 1.8H6.173l3.963 3.964a.9.9 0 1 1-1.272 1.272l-5.5-5.5A.9.9 0 0 1 3.1 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-left"],
  category: "utility"
}, Fr = (e) => /* @__PURE__ */ l(pr, { ...e, svg: Ce });
Fr.displayName = "IconArrowLeft";
const Pe = {
  name: "arrow-right",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.9 12a.9.9 0 0 1-.264.636l-5.5 5.5a.9.9 0 0 1-1.272-1.272l3.963-3.964H4a.9.9 0 0 1 0-1.8h13.827l-3.963-3.964a.9.9 0 1 1 1.272-1.272l5.5 5.5A.9.9 0 0 1 20.9 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["arrow-right"],
  category: "utility"
}, Tr = (e) => /* @__PURE__ */ l(pr, { ...e, svg: Pe });
Tr.displayName = "IconArrowRight";
function dr(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function ze(...e) {
  return (n) => {
    let t = !1;
    const a = e.map((p) => {
      const r = dr(p, n);
      return !t && typeof r == "function" && (t = !0), r;
    });
    if (t)
      return () => {
        for (let p = 0; p < a.length; p++) {
          const r = a[p];
          typeof r == "function" ? r() : dr(e[p], null);
        }
      };
  };
}
var Jr = s.forwardRef((e, n) => {
  const { children: t, ...a } = e, p = s.Children.toArray(t), r = p.find(ke);
  if (r) {
    const i = r.props.children, o = p.map((g) => g === r ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : g);
    return /* @__PURE__ */ l(rr, { ...a, ref: n, children: s.isValidElement(i) ? s.cloneElement(i, void 0, o) : null });
  }
  return /* @__PURE__ */ l(rr, { ...a, ref: n, children: t });
});
Jr.displayName = "Slot";
var rr = s.forwardRef((e, n) => {
  const { children: t, ...a } = e;
  if (s.isValidElement(t)) {
    const p = Me(t), r = Re(a, t.props);
    return t.type !== s.Fragment && (r.ref = n ? ze(n, p) : p), s.cloneElement(t, r);
  }
  return s.Children.count(t) > 1 ? s.Children.only(null) : null;
});
rr.displayName = "SlotClone";
var Ae = ({ children: e }) => /* @__PURE__ */ l(nr, { children: e });
function ke(e) {
  return s.isValidElement(e) && e.type === Ae;
}
function Re(e, n) {
  const t = { ...n };
  for (const a in n) {
    const p = e[a], r = n[a];
    /^on[A-Z]/.test(a) ? p && r ? t[a] = (...i) => {
      r(...i), p(...i);
    } : p && (t[a] = p) : a === "style" ? t[a] = { ...p, ...r } : a === "className" && (t[a] = [p, r].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function Me(e) {
  var n, t;
  let a = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, p = a && "isReactWarning" in a && a.isReactWarning;
  return p ? e.ref : (a = (t = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : t.get, p = a && "isReactWarning" in a && a.isReactWarning, p ? e.props.ref : e.props.ref || e.ref);
}
var Ee = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], qe = Ee.reduce((e, n) => {
  const t = s.forwardRef((a, p) => {
    const { asChild: r, ...i } = a, o = r ? Jr : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...i, ref: p });
  });
  return t.displayName = `Primitive.${n}`, { ...e, [n]: t };
}, {}), De = "VisuallyHidden", Kr = s.forwardRef(
  (e, n) => /* @__PURE__ */ l(
    qe.span,
    {
      ...e,
      ref: n,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Kr.displayName = De;
var Ve = Kr;
const k = ({
  asChild: e,
  children: n,
  className: t = "",
  ["data-testid"]: a
}) => /* @__PURE__ */ l(Ve, { asChild: e, "data-testid": a, className: t, children: n });
function Be(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Q = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var fr;
function We() {
  return fr || (fr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a.call(this, o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, this && this[o] || o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(Q)), Q.exports;
}
var Ze = We();
const z = /* @__PURE__ */ Be(Ze), Qr = (e) => {
  window.location.href = e;
}, He = {
  "purpur-pagination": "_purpur-pagination_vsyxu_1",
  "purpur-pagination__pagination-container": "_purpur-pagination__pagination-container_vsyxu_5",
  "purpur-pagination__pagination-container--with-page-size-select": "_purpur-pagination__pagination-container--with-page-size-select_vsyxu_12",
  "purpur-pagination__page-size-select-container": "_purpur-pagination__page-size-select-container_vsyxu_20",
  "purpur-pagination__page-navigation-container": "_purpur-pagination__page-navigation-container_vsyxu_30",
  "purpur-pagination__step-trigger-label": "_purpur-pagination__step-trigger-label_vsyxu_51",
  "purpur-pagination__step-trigger": "_purpur-pagination__step-trigger_vsyxu_51",
  "purpur-pagination__page-trigger-container": "_purpur-pagination__page-trigger-container_vsyxu_78",
  "purpur-pagination__pages": "_purpur-pagination__pages_vsyxu_83",
  "purpur-pagination__pages--visible": "_purpur-pagination__pages--visible_vsyxu_86",
  "purpur-pagination__page-selector": "_purpur-pagination__page-selector_vsyxu_94",
  "purpur-pagination__page-selector--visible": "_purpur-pagination__page-selector--visible_vsyxu_97"
};
function mr(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Le(...e) {
  return (n) => {
    let t = !1;
    const a = e.map((p) => {
      const r = mr(p, n);
      return !t && typeof r == "function" && (t = !0), r;
    });
    if (t)
      return () => {
        for (let p = 0; p < a.length; p++) {
          const r = a[p];
          typeof r == "function" ? r() : mr(e[p], null);
        }
      };
  };
}
var Ur = s.forwardRef((e, n) => {
  const { children: t, ...a } = e, p = s.Children.toArray(t), r = p.find(Te);
  if (r) {
    const i = r.props.children, o = p.map((g) => g === r ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : g);
    return /* @__PURE__ */ l(er, { ...a, ref: n, children: s.isValidElement(i) ? s.cloneElement(i, void 0, o) : null });
  }
  return /* @__PURE__ */ l(er, { ...a, ref: n, children: t });
});
Ur.displayName = "Slot";
var er = s.forwardRef((e, n) => {
  const { children: t, ...a } = e;
  if (s.isValidElement(t)) {
    const p = Ke(t), r = Je(a, t.props);
    return t.type !== s.Fragment && (r.ref = n ? Le(n, p) : p), s.cloneElement(t, r);
  }
  return s.Children.count(t) > 1 ? s.Children.only(null) : null;
});
er.displayName = "SlotClone";
var Fe = ({ children: e }) => /* @__PURE__ */ l(nr, { children: e });
function Te(e) {
  return s.isValidElement(e) && e.type === Fe;
}
function Je(e, n) {
  const t = { ...n };
  for (const a in n) {
    const p = e[a], r = n[a];
    /^on[A-Z]/.test(a) ? p && r ? t[a] = (...i) => {
      r(...i), p(...i);
    } : p && (t[a] = p) : a === "style" ? t[a] = { ...p, ...r } : a === "className" && (t[a] = [p, r].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function Ke(e) {
  var n, t;
  let a = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, p = a && "isReactWarning" in a && a.isReactWarning;
  return p ? e.ref : (a = (t = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : t.get, p = a && "isReactWarning" in a && a.isReactWarning, p ? e.props.ref : e.props.ref || e.ref);
}
var Qe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ue = Qe.reduce((e, n) => {
  const t = s.forwardRef((a, p) => {
    const { asChild: r, ...i } = a, o = r ? Ur : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...i, ref: p });
  });
  return t.displayName = `Primitive.${n}`, { ...e, [n]: t };
}, {}), Xe = "Label", Xr = s.forwardRef((e, n) => /* @__PURE__ */ l(
  Ue.label,
  {
    ...e,
    ref: n,
    onMouseDown: (t) => {
      var a;
      t.target.closest("button, input, select, textarea") || ((a = e.onMouseDown) == null || a.call(e, t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
    }
  }
));
Xr.displayName = Xe;
var Ye = Xr;
function Ge(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var vr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var hr;
function Ie() {
  return hr || (hr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a(o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(vr)), vr.exports;
}
var rt = Ie();
const et = /* @__PURE__ */ Ge(rt), U = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, X = "purpur-label", Yr = ({
  children: e,
  className: n,
  disabled: t,
  negative: a = !1,
  ...p
}) => {
  const r = et([
    n,
    U[X],
    {
      [U[`${X}--disabled`]]: t,
      [U[`${X}--negative`]]: a
    }
  ]);
  return /* @__PURE__ */ l(Ye, { className: r, ...p, children: e });
};
function tt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var $r;
function it() {
  return $r || ($r = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a(o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(yr)), yr.exports;
}
var nt = it();
const at = /* @__PURE__ */ tt(nt), R = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, pt = {
  PARAGRAPH100: "paragraph-100"
}, M = "purpur-paragraph", or = ({
  ["data-testid"]: e,
  children: n,
  className: t,
  disabled: a,
  enableHyphenation: p = !1,
  negative: r = !1,
  variant: i = pt.PARAGRAPH100,
  ...o
}) => {
  const g = at([
    t,
    R[M],
    R[`${M}--${i}`],
    {
      [R[`${M}--hyphens`]]: p,
      [R[`${M}--disabled`]]: a,
      [R[`${M}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ l("p", { ...o, className: g, "data-testid": e, children: n });
};
or.displayName = "Paragraph";
function ot(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var br = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var xr;
function lt() {
  return xr || (xr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a.call(this, o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, this && this[o] || o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(br)), br.exports;
}
var st = lt();
const ut = /* @__PURE__ */ ot(st), gt = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, ct = ut.bind(gt), wr = "purpur-icon", _t = "md", dt = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), ft = ({ content: e = "", title: n } = {}) => {
  const t = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], a = n ? `<title>${n}</title>` : "";
  return `<svg ${dt(t)}>${a}${e}</svg>`;
}, mt = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), Gr = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: t,
  className: a,
  size: p = _t,
  ...r
}) => {
  const i = ft({
    content: mt(n.svg),
    title: t
  }), o = ct(a, wr, `${wr}--${p}`);
  return /* @__PURE__ */ l(
    "span",
    {
      className: o,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: i },
      ...r
    }
  );
};
Gr.displayName = "Icon";
const vt = {
  name: "error-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" fill="currentColor"><path fill-rule="evenodd" d="M14.268 3.5c-.77-1.333-2.694-1.333-3.464 0l-8.66 15c-.77 1.333.192 3 1.732 3h17.32c1.54 0 2.502-1.667 1.733-3l-8.66-15Zm-.694 5.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.585 1.234-1.25 1.234-.648 0-1.25-.585-1.25-1.234 0-.633.602-1.234 1.25-1.234.665 0 1.25.601 1.25 1.234Z" clip-rule="evenodd"/></svg>',
  keywords: ["error-filled"],
  category: "status"
};
function ht(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Nr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Sr;
function yt() {
  return Sr || (Sr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a(o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(Nr)), Nr.exports;
}
var $t = yt();
const bt = /* @__PURE__ */ ht($t), jr = {
  "purpur-field-error-text": "_purpur-field-error-text_1lj7e_1",
  "purpur-field-error-text__icon": "_purpur-field-error-text__icon_1lj7e_11"
}, Or = "purpur-field-error-text", xt = ({
  children: e,
  className: n,
  ["aria-relevant"]: t = "additions text",
  ...a
}) => /* @__PURE__ */ f(
  "div",
  {
    className: bt([n, jr[Or]]),
    "aria-live": "assertive",
    "aria-relevant": t,
    ...a,
    children: [
      /* @__PURE__ */ l(Gr, { svg: vt, size: "xs", className: jr[`${Or}__icon`] }),
      e
    ]
  }
);
function wt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Cr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Pr;
function Nt() {
  return Pr || (Pr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a(o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(Cr)), Cr.exports;
}
var St = Nt();
const jt = /* @__PURE__ */ wt(St), zr = {
  "purpur-field-helper-text": "_purpur-field-helper-text_atw6b_1",
  "purpur-field-helper-text--disabled": "_purpur-field-helper-text--disabled_atw6b_9"
}, Ar = "purpur-field-helper-text", Ot = ({
  children: e,
  className: n,
  disabled: t,
  id: a,
  ...p
}) => {
  const r = jt([
    n,
    zr[Ar],
    {
      [zr[`${Ar}--disabled`]]: t
    }
  ]);
  return /* @__PURE__ */ l("span", { id: a, className: r, ...p, children: e });
};
function Ct(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var kr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Rr;
function Pt() {
  return Rr || (Rr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a.call(this, o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, this && this[o] || o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(kr)), kr.exports;
}
var zt = Pt();
const At = /* @__PURE__ */ Ct(zt), kt = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, Rt = At.bind(kt), Mr = "purpur-icon", Mt = "md", Et = (e) => e.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), qt = ({ content: e = "", title: n } = {}) => {
  const t = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], a = n ? `<title>${n}</title>` : "";
  return `<svg ${Et(t)}>${a}${e}</svg>`;
}, Dt = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), lr = ({
  ["data-testid"]: e,
  svg: n,
  allyTitle: t,
  className: a,
  size: p = Mt,
  ...r
}) => {
  const i = qt({
    content: Dt(n.svg),
    title: t
  }), o = Rt(a, Mr, `${Mr}--${p}`);
  return /* @__PURE__ */ l(
    "span",
    {
      className: o,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: i },
      ...r
    }
  );
};
lr.displayName = "Icon";
const Vt = {
  name: "check-circle-filled",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm4.712-12.491a.875.875 0 1 0-1.424-1.018l-4.4 6.16-2.27-2.27a.875.875 0 0 0-1.237 1.238l3 3a.875.875 0 0 0 1.331-.11l5-7Z" clip-rule="evenodd"/></svg>',
  keywords: ["check-circle-filled"],
  category: "status"
}, Ir = (e) => /* @__PURE__ */ l(lr, { ...e, svg: Vt });
Ir.displayName = "IconCheckCircleFilled";
const Bt = {
  name: "chevron-down",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.136 7.864a.9.9 0 0 0-1.272 0L12 14.727 5.136 7.864a.9.9 0 0 0-1.272 1.272l7.5 7.5a.9.9 0 0 0 1.272 0l7.5-7.5a.9.9 0 0 0 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["chevron-down"],
  category: "utility"
}, re = (e) => /* @__PURE__ */ l(lr, { ...e, svg: Bt });
re.displayName = "IconChevronDown";
function Er(e, n) {
  if (typeof e == "function")
    return e(n);
  e != null && (e.current = n);
}
function Wt(...e) {
  return (n) => {
    let t = !1;
    const a = e.map((p) => {
      const r = Er(p, n);
      return !t && typeof r == "function" && (t = !0), r;
    });
    if (t)
      return () => {
        for (let p = 0; p < a.length; p++) {
          const r = a[p];
          typeof r == "function" ? r() : Er(e[p], null);
        }
      };
  };
}
var ee = s.forwardRef((e, n) => {
  const { children: t, ...a } = e, p = s.Children.toArray(t), r = p.find(Ht);
  if (r) {
    const i = r.props.children, o = p.map((g) => g === r ? s.Children.count(i) > 1 ? s.Children.only(null) : s.isValidElement(i) ? i.props.children : null : g);
    return /* @__PURE__ */ l(tr, { ...a, ref: n, children: s.isValidElement(i) ? s.cloneElement(i, void 0, o) : null });
  }
  return /* @__PURE__ */ l(tr, { ...a, ref: n, children: t });
});
ee.displayName = "Slot";
var tr = s.forwardRef((e, n) => {
  const { children: t, ...a } = e;
  if (s.isValidElement(t)) {
    const p = Ft(t), r = Lt(a, t.props);
    return t.type !== s.Fragment && (r.ref = n ? Wt(n, p) : p), s.cloneElement(t, r);
  }
  return s.Children.count(t) > 1 ? s.Children.only(null) : null;
});
tr.displayName = "SlotClone";
var Zt = ({ children: e }) => /* @__PURE__ */ l(nr, { children: e });
function Ht(e) {
  return s.isValidElement(e) && e.type === Zt;
}
function Lt(e, n) {
  const t = { ...n };
  for (const a in n) {
    const p = e[a], r = n[a];
    /^on[A-Z]/.test(a) ? p && r ? t[a] = (...i) => {
      r(...i), p(...i);
    } : p && (t[a] = p) : a === "style" ? t[a] = { ...p, ...r } : a === "className" && (t[a] = [p, r].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function Ft(e) {
  var n, t;
  let a = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, p = a && "isReactWarning" in a && a.isReactWarning;
  return p ? e.ref : (a = (t = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : t.get, p = a && "isReactWarning" in a && a.isReactWarning, p ? e.props.ref : e.props.ref || e.ref);
}
var Tt = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Jt = Tt.reduce((e, n) => {
  const t = s.forwardRef((a, p) => {
    const { asChild: r, ...i } = a, o = r ? ee : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ l(o, { ...i, ref: p });
  });
  return t.displayName = `Primitive.${n}`, { ...e, [n]: t };
}, {}), Kt = "Label", te = s.forwardRef((e, n) => /* @__PURE__ */ l(
  Jt.label,
  {
    ...e,
    ref: n,
    onMouseDown: (t) => {
      var a;
      t.target.closest("button, input, select, textarea") || ((a = e.onMouseDown) == null || a.call(e, t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
    }
  }
));
te.displayName = Kt;
var Qt = te;
function Ut(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var qr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Dr;
function Xt() {
  return Dr || (Dr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a(o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(qr)), qr.exports;
}
var Yt = Xt();
const Gt = /* @__PURE__ */ Ut(Yt), Y = {
  "purpur-label": "_purpur-label_1jndl_1",
  "purpur-label--negative": "_purpur-label--negative_1jndl_8",
  "purpur-label--disabled": "_purpur-label--disabled_1jndl_11"
}, G = "purpur-label", It = ({
  children: e,
  className: n,
  disabled: t,
  negative: a = !1,
  ...p
}) => {
  const r = Gt([
    n,
    Y[G],
    {
      [Y[`${G}--disabled`]]: t,
      [Y[`${G}--negative`]]: a
    }
  ]);
  return /* @__PURE__ */ l(Qt, { className: r, ...p, children: e });
};
function ri(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Br;
function ei() {
  return Br || (Br = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a(o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(Vr)), Vr.exports;
}
var ti = ei();
const Wr = /* @__PURE__ */ ri(ti), ii = "_rotate_1xozj_1", ni = "_dash_1xozj_1", E = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: ii,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: ni,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, q = "purpur-spinner", ai = {
  SM: "sm"
}, pi = ({
  ["data-testid"]: e,
  disabled: n = !1,
  negative: t = !1,
  size: a = ai.SM,
  ...p
}) => /* @__PURE__ */ l(
  "div",
  {
    className: Wr([E[q], E[`${q}--${a}`]]),
    "data-testid": e,
    ...p,
    children: /* @__PURE__ */ l("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ l(
      "circle",
      {
        className: Wr(E[`${q}__circle`], {
          [E[`${q}__circle--disabled`]]: n,
          [E[`${q}__circle--negative`]]: t
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
);
function oi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Zr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var Hr;
function li() {
  return Hr || (Hr = 1, function(e) {
    (function() {
      var n = {}.hasOwnProperty;
      function t() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var o = arguments[i];
          o && (r = p(r, a.call(this, o)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return t.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var o in r)
          n.call(r, o) && r[o] && (i = p(i, this && this[o] || o));
        return i;
      }
      function p(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
    })();
  }(Zr)), Zr.exports;
}
var si = li();
const ui = /* @__PURE__ */ oi(si), gi = {
  "purpur-select": "_purpur-select_imnd8_1",
  "purpur-select__label": "_purpur-select__label_imnd8_7",
  "purpur-select__field-row": "_purpur-select__field-row_imnd8_12",
  "purpur-select__frame": "_purpur-select__frame_imnd8_16",
  "purpur-select__select-container": "_purpur-select__select-container_imnd8_23",
  "purpur-select__select-container--disabled": "_purpur-select__select-container--disabled_imnd8_31",
  "purpur-select__select-container--readonly": "_purpur-select__select-container--readonly_imnd8_34",
  "purpur-select__select": "_purpur-select__select_imnd8_23",
  "purpur-select__select--error": "_purpur-select__select--error_imnd8_83",
  "purpur-select__select--is-valid": "_purpur-select__select--is-valid_imnd8_86",
  "purpur-select__end-adornments": "_purpur-select__end-adornments_imnd8_92",
  "purpur-select__select-icon": "_purpur-select__select-icon_imnd8_102",
  "purpur-select__select-icon--readonly": "_purpur-select__select-icon--readonly_imnd8_105",
  "purpur-select__select-icon--disabled": "_purpur-select__select-icon--disabled_imnd8_105",
  "purpur-select__valid-icon": "_purpur-select__valid-icon_imnd8_108"
}, j = ui.bind(gi), _ = "purpur-select", ci = ({
  label: e,
  options: n,
  className: t,
  errorText: a,
  helperText: p,
  placeholder: r,
  readOnly: i = !1,
  ["data-testid"]: o,
  valid: g,
  loading: d,
  ...u
}, $) => {
  const c = (x) => o ? `${o}-${x}` : void 0, v = g && !a, N = ar(), b = u.id ?? N, S = p ? `${b}-helper-text` : void 0, O = j([
    `${_}__select-container`,
    {
      [`${_}__select-container--disabled`]: u.disabled,
      [`${_}__select-container--readonly`]: i && !u.disabled
    }
  ]);
  return j([
    `${_}__select-icon`,
    {
      [`${_}__select-icon--disabled`]: u.disabled,
      [`${_}__select-icon--readonly`]: i && !u.disabled,
      [`${_}__select-icon--is-valid`]: v
    }
  ]), v && j(`${_}__valid-icon`), /* @__PURE__ */ f("div", { className: j(_, t), children: [
    e && /* @__PURE__ */ f(
      It,
      {
        htmlFor: b,
        className: j(`${_}__label`),
        "data-testid": c("label"),
        disabled: u.disabled,
        children: [
          u.required && /* @__PURE__ */ l("span", { "aria-hidden": !0, children: "*" }),
          e
        ]
      }
    ),
    /* @__PURE__ */ l("div", { className: j(`${_}__field-row`), children: /* @__PURE__ */ f("div", { className: O, children: [
      /* @__PURE__ */ f(
        "select",
        {
          ...u,
          onChange: i || u == null ? void 0 : u.onChange,
          id: b,
          ref: $,
          "data-testid": c("select"),
          "aria-describedby": u["aria-describedby"] || S,
          "aria-invalid": u["aria-invalid"] || !!a,
          "aria-disabled": u["aria-disabled"] || u.disabled,
          "aria-readonly": u["aria-readonly"] || i && !u.disabled,
          className: j([
            `${_}__select`,
            {
              [`${_}__select--error`]: !!a,
              [`${_}__select--is-valid`]: v
            }
          ]),
          children: [
            r && /* @__PURE__ */ l("option", { value: r.value ?? r.label, disabled: !0, children: r.label }),
            n.map(
              (x, A) => _i(x) ? di(x, b, A, i) : ie(x, b, A, i)
            )
          ]
        }
      ),
      /* @__PURE__ */ f("div", { className: j(`${_}__end-adornments`), children: [
        d ? /* @__PURE__ */ l(
          pi,
          {
            disabled: u.disabled,
            size: "xxs",
            "data-testid": c("spinner")
          },
          "spinner"
        ) : /* @__PURE__ */ l(
          re,
          {
            className: j([
              `${_}__select-icon`,
              {
                [`${_}__select-icon--disabled`]: u.disabled,
                [`${_}__select-icon--readonly`]: i && !u.disabled,
                [`${_}__select-icon--is-valid`]: v
              }
            ]),
            "data-testid": c("dropdown-icon"),
            size: "sm"
          },
          "chevron-down-icon"
        ),
        v && /* @__PURE__ */ l(
          Ir,
          {
            "data-testid": c("valid-icon"),
            className: j(`${_}__valid-icon`)
          },
          "valid-icon"
        )
      ] }),
      /* @__PURE__ */ l("div", { className: j(`${_}__frame`) })
    ] }) }),
    S && /* @__PURE__ */ l(
      Ot,
      {
        disabled: u.disabled,
        "data-testid": c("helper-text"),
        id: S,
        children: p
      }
    ),
    a && /* @__PURE__ */ l(xt, { "data-testid": c("error-text"), children: a })
  ] });
}, _i = (e) => e.hasOwnProperty("options"), di = (e, n, t, a) => {
  const p = `${n}--group--${t}`;
  return /* @__PURE__ */ l("optgroup", { label: e.label, children: e.options.map((r, i) => ie(r, p, i, a)) }, p);
}, ie = (e, n, t, a) => /* @__PURE__ */ l(
  "option",
  {
    value: e.value ?? e.label,
    disabled: a,
    children: e.label
  },
  `${n}--option--${t}`
), sr = P(ci);
sr.displayName = "Select";
const fi = {
  "purpur-pagination-page-selector": "_purpur-pagination-page-selector_7pxsw_1",
  "purpur-pagination-page-selector__select-container": "_purpur-pagination-page-selector__select-container_7pxsw_6",
  "purpur-pagination-page-selector__of-total-pages-label": "_purpur-pagination-page-selector__of-total-pages-label_7pxsw_10"
}, mi = (e) => ({
  options: Lr(
    () => Array.from({ length: e }, (t, a) => ({ label: `${a + 1}`, value: `${a + 1}` })),
    [e]
  )
}), B = z.bind(fi), W = "purpur-pagination-page-selector", ne = P(
  ({
    ["data-testid"]: e = "purpur-pagination-page-selector",
    asLink: n,
    className: t,
    currentPage: a,
    hrefGetter: p,
    navigationFunction: r,
    numberOfPages: i,
    onPageChange: o,
    outOfLabel: g,
    pageSelectorId: d,
    pageSelectorLabel: u,
    ...$
  }, c) => {
    const v = ar(), N = B([t, W]), { options: b } = mi(i), S = (O) => {
      const x = O.target.value ? Number(O.target.value) : 1;
      if (o(x), n) {
        const A = (p == null ? void 0 : p(x)) ?? "";
        r(x, A);
      }
    };
    return /* @__PURE__ */ f("div", { className: N, "data-testid": e, ref: c, ...$, children: [
      /* @__PURE__ */ f("div", { className: B(`${W}__select-container`), children: [
        /* @__PURE__ */ l(k, { children: /* @__PURE__ */ l(Yr, { "data-testid": `${e}-label`, htmlFor: v, children: u }) }),
        /* @__PURE__ */ l(
          sr,
          {
            className: B(`${W}__select`),
            "data-testid": `${e}-select`,
            id: d ?? v,
            onChange: S,
            options: b,
            value: String(a)
          }
        )
      ] }),
      /* @__PURE__ */ l(
        or,
        {
          className: B(`${W}__of-total-pages-label`),
          "data-testid": `${e}-of-total-pages`,
          children: `${g} ${i}`
        }
      )
    ] });
  }
);
ne.displayName = "PaginationPageSelector";
const vi = {
  "purpur-pagination-page-size-selector": "_purpur-pagination-page-size-selector_11x2p_1",
  "purpur-pagination-page-size-selector__select": "_purpur-pagination-page-size-selector__select_11x2p_12",
  "purpur-pagination-page-size-selector__items-per-page-label": "_purpur-pagination-page-size-selector__items-per-page-label_11x2p_17",
  "purpur-pagination-page-size-selector__items-per-page-label-text": "_purpur-pagination-page-size-selector__items-per-page-label-text_11x2p_27"
}, hi = (e) => ({
  options: Lr(
    () => e.map((t) => ({
      label: `${t}`,
      value: `${t}`
    })),
    [e]
  )
}), Z = z.bind(vi), H = "purpur-pagination-page-size-selector", ae = P(
  ({
    ["data-testid"]: e = "purpur-pagination-page-size-selector",
    asLink: n,
    availablePageSizes: t,
    className: a,
    hrefGetter: p,
    navigationFunction: r,
    onPageSizeChange: i,
    pageSize: o,
    pageSizeLabel: g,
    ...d
  }, u) => {
    const $ = ar(), c = Z([a, H]), { options: v } = hi(t), N = (b) => {
      const S = Number(b.target.value);
      if (i(S), n) {
        const O = p({ page: 1, pageSize: S });
        r ? r({ currentPage: 1, pageSize: S, url: O }) : Qr(O);
      }
    };
    return /* @__PURE__ */ f("div", { className: c, "data-testid": e, ref: u, ...d, children: [
      /* @__PURE__ */ l(
        Yr,
        {
          className: Z(`${H}__items-per-page-label`),
          "data-testid": `${e}-item-per-page-label`,
          htmlFor: $,
          children: /* @__PURE__ */ l("span", { className: Z(`${H}__items-per-page-label-text`), children: g })
        }
      ),
      /* @__PURE__ */ l(
        sr,
        {
          className: Z(`${H}__select`),
          "data-testid": `${e}-select`,
          id: $,
          onChange: N,
          options: v,
          value: o
        }
      )
    ] });
  }
);
ae.displayName = "PaginationPageSizeSelector";
const yi = {
  "purpur-pagination-page-trigger": "_purpur-pagination-page-trigger_o6f2c_1",
  "purpur-pagination-page-trigger__trigger-item": "_purpur-pagination-page-trigger__trigger-item_o6f2c_4",
  "purpur-pagination-page-trigger__trigger-item--xs": "_purpur-pagination-page-trigger__trigger-item--xs_o6f2c_36",
  "purpur-pagination-page-trigger__trigger-item--icon-only": "_purpur-pagination-page-trigger__trigger-item--icon-only_o6f2c_39",
  "purpur-pagination-page-trigger__trigger-item--sm": "_purpur-pagination-page-trigger__trigger-item--sm_o6f2c_42",
  "purpur-pagination-page-trigger__trigger-item--md": "_purpur-pagination-page-trigger__trigger-item--md_o6f2c_48",
  "purpur-pagination-page-trigger__trigger-item--lg": "_purpur-pagination-page-trigger__trigger-item--lg_o6f2c_54",
  "purpur-pagination-page-trigger__trigger-item--full-width": "_purpur-pagination-page-trigger__trigger-item--full-width_o6f2c_60",
  "purpur-pagination-page-trigger__trigger-item--primary": "_purpur-pagination-page-trigger__trigger-item--primary_o6f2c_63",
  "purpur-pagination-page-trigger__trigger-item--disabled": "_purpur-pagination-page-trigger__trigger-item--disabled_o6f2c_67",
  "purpur-pagination-page-trigger__trigger-item--primary-negative": "_purpur-pagination-page-trigger__trigger-item--primary-negative_o6f2c_73",
  "purpur-pagination-page-trigger__trigger-item--secondary": "_purpur-pagination-page-trigger__trigger-item--secondary_o6f2c_85",
  "purpur-pagination-page-trigger__trigger-item--secondary-negative": "_purpur-pagination-page-trigger__trigger-item--secondary-negative_o6f2c_96",
  "purpur-pagination-page-trigger__trigger-item--expressive": "_purpur-pagination-page-trigger__trigger-item--expressive_o6f2c_107",
  "purpur-pagination-page-trigger__trigger-item--expressive-negative": "_purpur-pagination-page-trigger__trigger-item--expressive-negative_o6f2c_117",
  "purpur-pagination-page-trigger__trigger-item--page-trigger": "_purpur-pagination-page-trigger__trigger-item--page-trigger_o6f2c_129",
  "purpur-pagination-page-trigger__trigger-item--selected": "_purpur-pagination-page-trigger__trigger-item--selected_o6f2c_138"
}, L = z.bind(yi), m = "purpur-pagination-page-trigger", pe = P(
  ({
    ["data-testid"]: e = "purpur-pagination-page-trigger",
    linkElement: n,
    asLink: t,
    className: a,
    disabled: p,
    hrefGetter: r,
    onPageChange: i,
    pageNumber: o,
    selected: g,
    stepNumberPrefix: d,
    ...u
  }, $) => {
    const c = L([a, m]);
    return /* @__PURE__ */ l("li", { className: c, "data-testid": e, ref: $, ...u, children: t ? p ? /* @__PURE__ */ f(
      "span",
      {
        className: L([
          `${m}__trigger-item`,
          `${m}__trigger-item--page-trigger`,
          `${m}__trigger-item--sm`,
          `${m}__trigger-item--icon-only`,
          `${m}__trigger-item--disabled`
        ]),
        "aria-current": g ? "page" : void 0,
        "data-testid": `${e}-disabled-link`,
        children: [
          /* @__PURE__ */ l(k, { children: `${d} ` }),
          o
        ]
      }
    ) : /* @__PURE__ */ f(
      n,
      {
        className: L([
          `${m}__trigger-item`,
          `${m}__trigger-item--page-trigger`,
          `${m}__trigger-item--sm`,
          `${m}__trigger-item--icon-only`,
          { [`${m}__trigger-item--selected`]: g }
        ]),
        "aria-current": g ? "page" : void 0,
        "data-testid": `${e}-link`,
        href: r(o),
        onClick: () => i(o),
        children: [
          /* @__PURE__ */ l(k, { children: `${d} ` }),
          o
        ]
      }
    ) : /* @__PURE__ */ f(
      "button",
      {
        "aria-disabled": p,
        className: L([
          `${m}__trigger-item`,
          `${m}__trigger-item--page-trigger`,
          `${m}__trigger-item--sm`,
          `${m}__trigger-item--icon-only`,
          { [`${m}__trigger-item--selected`]: g }
        ]),
        "data-testid": `${e}-button`,
        "aria-current": g ? "page" : void 0,
        disabled: p,
        onClick: () => i(o),
        type: "button",
        children: [
          /* @__PURE__ */ l(k, { children: `${d} ` }),
          o
        ]
      }
    ) });
  }
);
pe.displayName = "PaginationPageTrigger";
const $i = {
  "purpur-pagination-pages": "_purpur-pagination-pages_2g8is_1"
}, bi = {
  "purpur-pagination-truncation-separator": "_purpur-pagination-truncation-separator_b9cij_1"
}, xi = z.bind(bi), wi = "purpur-pagination-truncation-separator", oe = ({
  ["data-testid"]: e = "purpur-pagination-truncation-separator",
  className: n,
  ...t
}) => {
  const a = xi([n, wi]);
  return /* @__PURE__ */ l("li", { className: a, "data-testid": e, ...t, children: /* @__PURE__ */ l(or, { children: "..." }) });
};
oe.displayName = "PaginationTruncationSeparator";
const Ni = z.bind($i), Si = "purpur-pagination-pages", le = P(
  ({
    ["data-testid"]: e = "purpur-pagination-pages",
    linkElement: n,
    asLink: t,
    className: a,
    currentPage: p,
    hrefGetter: r,
    onPageChange: i,
    pages: o,
    stepNumberPrefix: g,
    ...d
  }, u) => {
    const $ = Ni([a, Si]);
    return /* @__PURE__ */ l("ol", { className: $, "data-testid": e, ref: u, ...d, children: o.flatMap((c, v, N) => {
      const b = /* @__PURE__ */ me(
        pe,
        {
          ...t ? { asLink: !0, hrefGetter: r } : {
            asLink: void 0,
            hrefGetter: void 0
          },
          linkElement: n,
          "data-testid": `${e}-page-${c}`,
          key: c,
          onPageChange: i,
          selected: c === p,
          stepNumberPrefix: g,
          pageNumber: c
        }
      );
      return v === 0 || N[v - 1] + 1 === c ? [b] : [
        /* @__PURE__ */ l(
          oe,
          {
            "data-testid": `${e}-truncation-separator-${c}`
          },
          `${c}-separator`
        ),
        b
      ];
    }) });
  }
);
le.displayName = "PaginationPages";
const ji = {
  "purpur-pagination-step-trigger__trigger-item": "_purpur-pagination-step-trigger__trigger-item_cjk2t_1",
  "purpur-pagination-step-trigger__trigger-item--xs": "_purpur-pagination-step-trigger__trigger-item--xs_cjk2t_33",
  "purpur-pagination-step-trigger__trigger-item--icon-only": "_purpur-pagination-step-trigger__trigger-item--icon-only_cjk2t_36",
  "purpur-pagination-step-trigger__trigger-item--sm": "_purpur-pagination-step-trigger__trigger-item--sm_cjk2t_39",
  "purpur-pagination-step-trigger__trigger-item--md": "_purpur-pagination-step-trigger__trigger-item--md_cjk2t_45",
  "purpur-pagination-step-trigger__trigger-item--lg": "_purpur-pagination-step-trigger__trigger-item--lg_cjk2t_51",
  "purpur-pagination-step-trigger__trigger-item--full-width": "_purpur-pagination-step-trigger__trigger-item--full-width_cjk2t_57",
  "purpur-pagination-step-trigger__trigger-item--primary": "_purpur-pagination-step-trigger__trigger-item--primary_cjk2t_60",
  "purpur-pagination-step-trigger__trigger-item--disabled": "_purpur-pagination-step-trigger__trigger-item--disabled_cjk2t_64",
  "purpur-pagination-step-trigger__trigger-item--primary-negative": "_purpur-pagination-step-trigger__trigger-item--primary-negative_cjk2t_70",
  "purpur-pagination-step-trigger__trigger-item--secondary": "_purpur-pagination-step-trigger__trigger-item--secondary_cjk2t_82",
  "purpur-pagination-step-trigger__trigger-item--secondary-negative": "_purpur-pagination-step-trigger__trigger-item--secondary-negative_cjk2t_93",
  "purpur-pagination-step-trigger__trigger-item--expressive": "_purpur-pagination-step-trigger__trigger-item--expressive_cjk2t_104",
  "purpur-pagination-step-trigger__trigger-item--expressive-negative": "_purpur-pagination-step-trigger__trigger-item--expressive-negative_cjk2t_114",
  "purpur-pagination-step-trigger__trigger-item--step-trigger": "_purpur-pagination-step-trigger__trigger-item--step-trigger_cjk2t_126"
}, F = z.bind(ji), h = "purpur-pagination-step-trigger", ir = P(
  ({
    ["aria-label"]: e,
    ["data-testid"]: n = "purpur-pagination-step-trigger",
    linkElement: t,
    asLink: a,
    children: p,
    className: r,
    disabled: i,
    hrefGetter: o,
    onPageChange: g,
    pageToNavigateTo: d,
    ...u
  }, $) => {
    const c = F([r, h]);
    return /* @__PURE__ */ l("div", { className: c, "data-testid": n, ref: $, ...u, children: a ? i ? /* @__PURE__ */ l(
      "span",
      {
        "aria-label": e,
        className: F([
          `${h}__trigger-item`,
          `${h}__trigger-item--step-trigger`,
          `${h}__trigger-item--secondary`,
          `${h}__trigger-item--sm`,
          `${h}__trigger-item--disabled`
        ]),
        "data-testid": `${n}-disabled-link`,
        children: p
      }
    ) : /* @__PURE__ */ l(
      t,
      {
        "aria-label": e,
        className: F([
          `${h}__trigger-item`,
          `${h}__trigger-item--step-trigger`,
          `${h}__trigger-item--secondary`,
          `${h}__trigger-item--sm`
        ]),
        "data-testid": `${n}-link`,
        href: o(d),
        onClick: () => g(d),
        children: p
      }
    ) : /* @__PURE__ */ l(
      "button",
      {
        "aria-disabled": i,
        "aria-label": e,
        className: F([
          `${h}__trigger-item`,
          `${h}__trigger-item--step-trigger`,
          `${h}__trigger-item--secondary`,
          `${h}__trigger-item--sm`,
          { [`${h}__trigger-item--disabled`]: i }
        ]),
        "data-testid": `${n}-button`,
        disabled: i,
        onClick: () => g(d),
        type: "button",
        children: p
      }
    ) });
  }
);
ir.displayName = "PaginationStepTrigger";
const Oi = (e, n, t) => {
  const [a, p] = I.useState([]), [r, i] = I.useState(0);
  return ve(() => {
    const o = Math.ceil(e / n);
    i(o), p(Ci(o, t));
  }, [e, n, t]), {
    pages: a,
    numberOfPages: r
  };
};
function Ci(e, n) {
  if (e <= 5)
    return Array.from({ length: e }, (p, r) => r + 1);
  const t = [1, 2, 3];
  if (t.includes(n))
    return [...t, 4, e];
  const a = [e - 2, e - 1, e];
  return a.includes(n) ? [1, e - 3, ...a] : [1, n - 1, n, n + 1, e];
}
const w = z.bind(He), y = "purpur-pagination", Pi = P(
  ({
    ["data-testid"]: e = "purpur-pagination",
    linkElement: n = "a",
    asLink: t,
    availablePageSizes: a,
    className: p,
    currentPage: r = 1,
    hrefGetter: i,
    navigationFunction: o,
    nextButtonAriaLabel: g,
    nextButtonText: d,
    onPageChange: u,
    outOfLabel: $,
    pageSelectorId: c,
    pageSelectorLabel: v,
    pageSize: N = 10,
    pageSizeLabel: b,
    previousButtonAriaLabel: S,
    previousButtonText: O,
    stepNumberPrefix: x,
    totalItems: A,
    ...se
  }, ue) => {
    const ge = w([p, y]), [T, ce] = I.useState(N), { pages: J, numberOfPages: K } = Oi(A, T, r), D = (C) => {
      u == null || u({ currentPage: C, pageSize: N });
    }, _e = (C) => (i == null ? void 0 : i({ page: C, pageSize: N })) ?? "", de = (C) => {
      ce(C), u == null || u({ currentPage: 1, pageSize: C });
    }, fe = (C, ur) => {
      o ? o({ currentPage: C, pageSize: T, url: ur }) : Qr(ur);
    }, V = t ? { asLink: !0, hrefGetter: _e } : {
      asLink: void 0,
      hrefGetter: void 0
    };
    return /* @__PURE__ */ l(t ? "nav" : "div", { className: ge, "data-testid": e, ref: ue, ...se, children: /* @__PURE__ */ f(
      "div",
      {
        className: w([
          `${y}__pagination-container`,
          {
            [`${y}__pagination-container--with-page-size-select`]: !!a
          }
        ]),
        children: [
          a && /* @__PURE__ */ l("div", { className: w(`${y}__page-size-select-container`), children: /* @__PURE__ */ l(
            ae,
            {
              ...t ? { asLink: !0, hrefGetter: i, navigationFunction: o } : { asLink: void 0, hrefGetter: void 0 },
              availablePageSizes: a,
              className: w(`${y}__page-size-selector`),
              "data-testid": `${e}-page-size-selector`,
              onPageSizeChange: de,
              pageSize: T,
              pageSizeLabel: b
            }
          ) }),
          /* @__PURE__ */ f("div", { className: w(`${y}__page-navigation-container`), children: [
            /* @__PURE__ */ f(
              ir,
              {
                ...V,
                linkElement: n,
                "aria-label": S,
                className: w(`${y}__step-trigger`),
                "data-testid": `${e}-previous-step-trigger`,
                disabled: r === 1,
                onPageChange: D,
                pageToNavigateTo: r - 1,
                children: [
                  /* @__PURE__ */ l(Fr, { size: "sm" }),
                  /* @__PURE__ */ l("span", { className: w(`${y}__step-trigger-label`), children: O }),
                  r !== 1 && /* @__PURE__ */ l(k, { "data-testid": `${e}-previous-step-trigger-hidden-text`, children: `${x} ${r - 1}` })
                ]
              }
            ),
            /* @__PURE__ */ f("div", { className: w(`${y}__page-trigger-container`), children: [
              /* @__PURE__ */ l(
                ne,
                {
                  ...V,
                  className: w([
                    `${y}__page-selector`,
                    { [`${y}__page-selector--visible`]: J.length > 3 }
                  ]),
                  currentPage: r,
                  "data-testid": `${e}-page-selector`,
                  navigationFunction: fe,
                  numberOfPages: K,
                  onPageChange: D,
                  outOfLabel: $,
                  pageSelectorId: c,
                  pageSelectorLabel: v
                }
              ),
              /* @__PURE__ */ l(
                le,
                {
                  ...V,
                  linkElement: n,
                  className: w([
                    `${y}__pages`,
                    { [`${y}__pages--visible`]: J.length <= 3 }
                  ]),
                  currentPage: r,
                  "data-testid": `${e}-pages`,
                  stepNumberPrefix: x,
                  onPageChange: D,
                  pages: J
                }
              )
            ] }),
            /* @__PURE__ */ f(
              ir,
              {
                ...V,
                linkElement: n,
                "aria-label": g,
                className: w(`${y}__step-trigger`),
                "data-testid": `${e}-next-step-trigger`,
                disabled: r === K,
                onPageChange: D,
                pageToNavigateTo: r + 1,
                children: [
                  /* @__PURE__ */ l("span", { className: w(`${y}__step-trigger-label`), children: d }),
                  r !== K && /* @__PURE__ */ l(k, { "data-testid": `${e}-next-step-trigger-hidden-text`, children: `${x} ${r + 1}` }),
                  /* @__PURE__ */ l(Tr, { size: "sm" })
                ]
              }
            )
          ] })
        ]
      }
    ) });
  }
);
Pi.displayName = "Pagination";
export {
  Pi as Pagination
};
//# sourceMappingURL=pagination.es.js.map
